<template>
  <svg
    class="svg-warning"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path
      fill="currentColor"
      d="M14.667 10.667h2.667v10.667h-2.667v-10.667zM14.667 24h2.667v2.667h-2.667v-2.667zM18.696 0h-5.392l-13.304 28.358v3.642h32v-3.642zM29.333 29.333h-26.667v-0.381l12.331-26.285h2.004l12.331 26.285z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgWarning',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
